const StatCardSkeleton = () => (
    <div className="bg-gray-100 border-2 border-white rounded-2xl p-6 shadow-lg animate-pulse">
        <div className="flex items-center justify-between mb-4">
            <div className="p-3 bg-gray-300 rounded-xl w-12 h-12"></div>
        </div>
        <div className="space-y-3">
            <div className="h-8 bg-gray-300 rounded w-1/2"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        </div>
    </div>
);

export default StatCardSkeleton;